var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarenkorb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warenkorb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M5.6 2.56h33V42h-33z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warenkorb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.65 41H8.55a1.76 1.76 0 01-1.79-2l2.77-22.95a2.34 2.34 0 012.28-2h2.3v5h2.5V14h11.48v5h2.5v-5h1.8a2.34 2.34 0 012.28 2l2.77 23a1.76 1.76 0 01-1.79 2m-7.56-28H16.61v-1.7a5.74 5.74 0 1111.48 0zm10.5 27l-3-25a2.31 2.31 0 00-2.24-2h-2.76v-2.45a8 8 0 00-8-8h-.5a8 8 0 00-8 8V13h-3.22a2.31 2.31 0 00-2.24 2l-3 25a1.73 1.73 0 001.76 2h29.44a1.73 1.73 0 001.76-2",
    fill: "#1d1d1b"
  }))));
}

export default SvgWarenkorb;